module.exports = __webpack_public_path__ + "img/women'sclothing.615c3d4f.jpg";